module.exports = __webpack_public_path__ + "img/wheel-of-fortune-preview.05be08c5.png";